module.exports = __webpack_public_path__ + "img/de6c58b.png";